import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import logo from "../../assets/logo_fixed.svg";
import "./Navbar.css";

export default function Navbar({ cartCount }) {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const isActive = (path) => location.pathname === path;

  return (
    <div className="nav">
      {/* LOGO */}
      <div className="logo" onClick={() => navigate("/")}>
        <img
          src={logo}
          alt="NASTY AUTHENTIC"
          loading="eager"
          fetchPriority="high"
          decoding="async"
        />
      </div>

      {/* HAMBURGER */}
      <button className="menu-btn" onClick={() => setOpen(!open)}>
        {open ? "✕" : "☰"}
      </button>

      <div className={`nav-links ${open ? "open" : ""}`}>
        {[
          { name: "HOME", path: "/" },
          { name: "PRODUCTS", path: "/products" },
          { name: "BLOG", path: "/blog" },
          { name: "ABOUT", path: "/about" },
          { name: "CONTACT", path: "/contact" },
        ].map((item) => (
          <Link
            key={item.path}
            to={item.path}
            className={`nav-link ${isActive(item.path) ? "active" : ""}`}
            onClick={() => setOpen(false)}
          >
            {item.name}
          </Link>
        ))}

        <Link to="/admin" className="nav-link" onClick={() => setOpen(false)}>
          ADMIN
        </Link>

        <button
          className="cart-btn"
          onClick={() => {
            navigate("/cart");
            setOpen(false);
          }}
        >
          CART{" "}
          {cartCount > 0 && <span className="cart-badge">{cartCount}</span>}
        </button>
      </div>
    </div>
  );
}
